/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BroadcastMessageModel } from '../../models/broadcast-message-model';

export interface BroadcastMessageIdGet$Params {
  id: string;
}

export function broadcastMessageIdGet(http: HttpClient, rootUrl: string, params: BroadcastMessageIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<BroadcastMessageModel>> {
  const rb = new RequestBuilder(rootUrl, broadcastMessageIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<BroadcastMessageModel>;
    })
  );
}

broadcastMessageIdGet.PATH = '/BroadcastMessage/{id}';
